import { useQuery } from "@apollo/client";
import {GET_ORG_ID} from '../api/queries/queries_local'


  const getMarketName=(orgId)=>{
    const getOrg = useQuery(GET_ORG_ID, {
        variables: { id: orgId }
      });
    return getOrg.data?.getOrg?  getOrg.data?.getOrg.market.name:'';
  }
  export default getMarketName;